import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="company_news" pageTitle="公司新闻" pageDescription="QbD Group 的最新公告、合作伙伴关系和重要里程碑——及时了解我们的发展与影响力。" />;

export const Route = createFileRoute("/zh-cn/news/")({
  head: () => buildRouteHead("/zh-cn/news"),
  component: ContentListingRoute,
});

